import React from 'react'
import { Col, NavItem, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import footer_logo from '../../../images/logoinwhite.png';
import { BRAND_ADDRESS, BRAND_EMAIL } from '../../../functions';

const Footer2 = () => {
  return (
    <>
      <section className='publicfooter2'>
        <Col xxl={'9'} xl={'9'} lg={'10'} className={'mx-auto col-11'}>
          <Row>
            <Col xxl={'6'} xl={'6'} lg={'6'}>
              <Link to={`/`}><img className={'img-fluid fluid footerimg'} src={footer_logo} alt={'icon'} /></Link>
              <p className='m-0 p-0 mt-4 graytext'>{BRAND_ADDRESS}</p>
              <p className='m-0 p-0 mt-2 graytext fontweight500'>{BRAND_EMAIL}</p>
            </Col>
            <Col xxl={'6'} xl={'6'} lg={'6'}>
              <Row>
                <Col xxl={'6'} xl={'6'} lg={'6'} md={'6'} sm={'12'}>
                  <div>
                    <h5 className='fontsize20 fontweight600 mb-3'>Company</h5>
                    <NavItem><Link className={'nav-link fontsize16  graytext mb-1'} to={`/`}>Home</Link></NavItem>
                    <NavItem><Link className={'nav-link fontsize16  graytext mb-1'} to={`/aboutus`}>About Us</Link></NavItem>
                    <NavItem><Link className={'nav-link fontsize16  graytext mb-1'} to={`/contactus`}>Contact Us</Link></NavItem>
                  </div>
                </Col>
                <Col xxl={'6'} xl={'6'} lg={'6'} md={'6'} sm={'12'}>
                  <div>
                    <h5 className='fontsize20 fontweight600 mb-3'>Newsletter</h5>
                    <p className='m-0 p-0 mt-2 graytext fontweight500'>Sign up for our mailing list to get latest updates and offers.</p>
                  </div>
                </Col>
                {/* <Col xxl={'4'} xl={'4'} lg={'4'} md={'6'} sm={'12'}>
                  <div>
                    <h5 className='fontsize20 fontweight500 whitetext mb-3'>Portal</h5>
                    <NavItem><Link className={'nav-link fontsize16  whitetext mb-1'} to={`/signin`}>Login</Link></NavItem>
                    <NavItem><Link className={'nav-link fontsize16  whitetext mb-1'} to={`/signup`}>Register</Link></NavItem>
                  </div>
                </Col> */}
              </Row>
            </Col>
          </Row>
        </Col>
      </section>
    </>
  )
}

export default Footer2
